import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { pathForPage, isSupportedLocale } from '../routes';
import { useTranslation } from 'react-i18next';
import { useLocaleRoute } from '../hooks/useLocaleRoute';

/**
 * Keep i18n language in sync with the locale segment in the URL.
 *
 * @returns {null}
 */
export function LocaleSync() {
  const { locale, page } = useLocaleRoute();
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    const active = i18n.resolvedLanguage || i18n.language;

    if (active !== locale) {
      i18n.changeLanguage(locale);
    }

    document.documentElement.lang = locale;
    const canonicalPath = pathForPage(page === 'homepagePreview' ? 'home' : page, locale);
    const params = new URLSearchParams(location.search);
    if (isSupportedLocale(params.get('lng'))) params.delete('lng');
    const search = params.toString() ? `?${params}` : '';
    if (location.pathname !== canonicalPath || location.search !== search) {
      navigate(`${canonicalPath}${search}${location.hash}`, { replace: true });
    }
  }, [locale, page, i18n, location.pathname, location.search, location.hash, navigate]);

  return null;
}
